<style lang="less" scoped>
  @pic_height: calc((85vh - 32px)/4);
.model-img{
  text-align: center;
  align-items: center;
  height: @pic_height;
  display: flex;
  flex-direction: column-reverse;
  overflow: hidden;
  >img{
    max-height: calc(@pic_height - 33px);
  }
  >div{
    width: 100%;
    line-height: 32px;
    .el-button{margin-left: 8px;}
  }
}
  .el-pagination{
    position: absolute;
    width: 100%;
    bottom: 0;
  }
</style>

<template>
  <div v-if="bucketId">
    <div v-if="total===0" style="padding: 20px; font-size: 16px;">
      <i class="el-icon-warning" style="color: orange"></i>
      无数据</div>
    <el-row :gutter="20" style="margin: 0">
      <el-col :span="4" v-for="e of models" :key="e.id">
        <div class="model-img">
          <div>
            {{e.updateTime | date_time}}
            <el-button style="color: #ff4d51" icon="el-icon-delete" type="text" @click="deleteImage(e)"></el-button>
          </div>
          <img :src="src(e)" :title="e.query">
        </div>
      </el-col>
    </el-row>
    <el-pagination style="text-align: center; "
                   :total="total" :layout="'prev, pager, next, ->, total'"
                   :current-page="page + 1"
                   :page-size="size"
                   @current-change="pageChange"
                   hide-on-single-page
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    bucketId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      page: 0,
      size: 24,
      total: 0,
      models: []
    }
  },
  watch:{
    page() {
      this.loadModel()
    },
    queryOpts: {
      handler: function (v) {
        console.log(v)
        this.loadModel()
      },
      deep: true
    }
  },
  computed: {
    queryOpts() {
      return {
        page: this.page,
        size: this.size,
        bucket: this.bucketId
      }
    }
  },
  methods: {
    src(e) {
      return this.$api.model.image({ ...e, key: e.query });
    },
    async loadModel() {
      if (!this.bucketId) {
        this.closeDialog();
        this.$message.error("缺少人脸库ID");
      }else{
        let res = await this.$request(this.$api.model.list(this.queryOpts));
        this.models = res.list;
        this.total = res.total;
      }
    },
    pageChange(page) {
      this.page = page - 1;
    },
    deleteImage(pic){
      this.$confirm('确认删除此人脸信息？', '提示', {
        confirmButtomText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(pic);
        this.$message({
          type: 'success',
          message: '删除成功'
        });
      })
    },
    async handleDelete(pic){
      let res = await this.$request(this.$api.model.remove({
        bucket: pic.bucket,
        key: pic.query
      }))
      this.loadModel();
    }
  },
  mounted() {
    this.loadModel();
  }
};
</script>

<style>
</style>
